import { useRecoilValue } from "recoil"
import { queryStyle } from "../styling"
import { useMemo } from "react"

export const useStyle = (organisationAddress: string | undefined) => {
    const style = useRecoilValue(queryStyle(organisationAddress))
    return style
}
